import React from 'react';
import styles from './styles.module.less';

type TMobileBanner = {
  title?: string;
  english_title?: string;
  intro?: string;
}

const MobileBanner:React.FC<TMobileBanner> = ({title,english_title,intro}) => {
  return (
    <div>
      <h3 className={styles.title}>{title}</h3>
      <h3 className={styles.subtitle}>{intro}</h3>
    </div>
  )
}
export default MobileBanner;
